import React from 'react'
import "./Services.css";
import { NavLink } from 'react-router-dom'
import { BASE_URL } from '../../../Components/Base_url/Base_Url';
import { FaWhatsapp } from "react-icons/fa";

<i className="fas fa-concierge-bell"></i>
function Service_card({ servi }) {
    return (
        <div className="tab-content active">

            <h6 className="service-count"> <i className="fas fa-concierge-bell"></i>{servi.services?.length} Services</h6>

            <div className="tours-grid">
                {servi?.services?.map((ser, index) => (
                    <div className="tour-card" key={index}>
                        <div className="card-image">
                            {/* Image ko clickable banaya */}
                            <NavLink to={`/service-detail/${ser.slug}`}>
                                <img src={`${BASE_URL}${ser?.img}`} alt={ser?.name} />
                            </NavLink>
                            <div className="badge">{ser?.name}</div>
                            {/* <div className="discount-badge">20% OFF</div> */}
                        </div>
                        <div className="card-content">
                            <h3 className="tour-title">
                                <NavLink to={`/service-detail/${ser.slug}`}>
                                    {ser?.name}
                                </NavLink>
                            </h3>
                            {/* <p className="tour-description">{ser?.Paragraph}</p> */}
                            <p className="d-block" dangerouslySetInnerHTML={{ __html: ser?.Paragraph }} />
                            <div className="tour-meta">
                                <div className="tour-duration">
                                    <i className="far fa-clock" />
                                    {/* <span>7 Days</span> */}
                                </div>
                                <div className="tour-rating">
                                    <div className="stars">
                                        <i className="fas fa-star" />
                                        <i className="fas fa-star" />
                                        <i className="fas fa-star" />
                                        <i className="fas fa-star" />
                                        <i className="fas fa-star-half-alt" />
                                    </div>
                                    {/* <span className="review-count">(124)</span> */}
                                </div>
                            </div>

                            <div className="tour-price-book">
                                {/* <div className="price">$899 <span>/ person</span></div> */}
                                <NavLink to={`/service-detail/${ser.slug}`}> <button className="book-btn">view Details</button></NavLink>
                                <a
                                    href={`https://wa.me/9116839808?text=Hi, I am interested in the ${ser.name} package.`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="book-btn-whats"
                                >
                                    <FaWhatsapp size={20} /> WhatsApp
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Service_card
